import { formatTimeWithoutMs } from '@com/utils/data-format'
export const FPS = 30

export function isFullFrame(duration: number): boolean {
  const v = duration % 100
  return [0, 33, 66].includes(Math.floor(v))
}

/**
 * 时长转帧数
 * @param duration 时长
 * @returns 帧数
 */
export function durationToFrames(duration: number, rounding = true): number {
  const frameDuration = 1000 / FPS
  if (!rounding && !isFullFrame(duration)) {
    const fullDuration = getFullFrameMs(duration, {
      rounding: 'ceil',
    })
    const full = Math.round(fullDuration / frameDuration)
    const over = (fullDuration - duration) / frameDuration

    return full - over
  }

  return Math.round(duration / frameDuration)
}

export function framesToDuration(frames: number): number {
  const frameDuration = 1000 / FPS
  return Math.floor(frames * frameDuration)
}

/**
 * 获取满帧（四舍五入）的时长
 * @param frames 帧数
 * @returns 时长
 */
export function getFullFrameMs(
  duration: number,
  options?: { max?: number; rounding: 'floor' | 'ceil' },
): number {
  if (isFullFrame(duration)) {
    return duration
  }

  const { max, rounding } = options ?? {}
  const frameDuration = 1000 / FPS
  let ms = Math.round(duration / frameDuration) * frameDuration

  if (rounding === 'floor') {
    ms = Math.floor(duration / frameDuration) * frameDuration
  } else if (rounding === 'ceil') {
    ms = Math.ceil(duration / frameDuration) * frameDuration
  }

  return Math.min(Math.floor(ms), max ?? Infinity)
}

/**
 * 格式化时长展示
 * @param duration 时长
 * @returns 格式化后的时长
 */
export function formatDuration(duration: number): string {
  const ms = duration % 1000
  const frames = Number(durationToFrames(ms, false).toFixed(1))
  return `${formatTimeWithoutMs(duration)}:${
    frames < 10 ? `0${frames}` : frames
  }`
}
